import React, { useEffect } from 'react';
import './Notification.scss';

export default function Notification(props){
    useEffect(()=>{
        if(props.timed){
            setTimeout(()=>props.onClose(), props.timed)
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div className={"notification " + (props.type || ' success')}>
            <div className="notification-content">
                <div className="close-notification" onClick={()=>props.onClose()}>
                    <span className="material-symbols material-symbols-outlined">close</span>
                </div>
                { props.title ? <h4 className="notification-title">{props.title}</h4> : '' }
                <span className="notification-message">{props.children||props.message||''}</span>
            </div>
        </div>
    );
}